/** The five stored rubric factors. Budget is the sixth, derived from the task's own budget_usd. */
export const TRUST_FACTOR_KEYS = ["access", "money", "data", "people", "safety"] as const;
export type TrustFactorKey = (typeof TRUST_FACTOR_KEYS)[number];

/** 4 = least sensitive ("none"), 1 = most sensitive. */
export type TrustLevel = 1 | 2 | 3 | 4;
/** Level 4: the factor does not apply. Stored factors omit it. */
export const NO_SENSITIVITY = 4 as const;
/** Select order in the creator review: "none" first. */
export const TRUST_LEVELS_LEAST_FIRST: readonly TrustLevel[] = [4, 3, 2, 1];
export type TrustFactors = Partial<Record<TrustFactorKey, TrustLevel>>;

/** Effective grade (shown as a level: 4 Easy … 1 Expert). 0 is Special, which only an admin can set; lower is always more sensitive. */
export type TrustGrade = 0 | 1 | 2 | 3 | 4;
export const SPECIAL_GRADE = 0 as const;

export const TRUST_FACTOR_SOURCES = ["ai", "creator_edited", "heuristic", "none"] as const;
export type TrustFactorsSource = (typeof TRUST_FACTOR_SOURCES)[number];

export type TrustReason = TrustFactorKey | "budget";

/** Trust columns as they appear on a mapped Task. */
export interface TaskTrustFields {
  trustGrade: TrustGrade;
  trustFactors: TrustFactors;
  trustFactorsSource: TrustFactorsSource;
  trustSpecialSuggested: boolean;
  /** True when an admin override is in force. The reason is admin-only and never on the task row. */
  trustGradeOverridden: boolean;
}

/** One row of public.admin_trust_grade_stats, camelCased. */
export interface TrustGradeStatsRow {
  grade: TrustGrade;
  taskCount: number;
  openCount: number;
  inProgressCount: number;
  doneCount: number;
  cancelledCount: number;
  disputedCount: number;
  medianHoursToFirstProposal: number | null;
  avgBudgetUsd: number | null;
  creatorEditedCount: number;
  heuristicCount: number;
  overriddenCount: number;
  overridesUp: number;
  overridesDown: number;
}
